import React from 'react';

const styles = {
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '1rem 0',
  },
  cardLeft: {
    flex: '0 0 50%',
    maxWidth: '50%',
    padding: '0.5rem',
  },
  cardRight: {
    flex: '0 0 50%',
    maxWidth: '50%',
    padding: '0.5rem',
  },
  skeletonBox: {
    backgroundColor: '#333',
    borderRadius: '8px',
    height: '180px',
    width: '100%',
  },
};

export default function Card2Skeleton({ rows = 2 }) {
  return (
    <section className="container" style={styles.container}>
      {[...Array(rows)].map((_, index) => {
        const isEven = index % 2 === 0;
        return (
          <div className="row" style={styles.row} key={index}>
            <div
              className="col-lg-5 col-6"
              style={isEven ? styles.cardLeft : styles.cardRight}
            >
              <div style={styles.skeletonBox}></div>
            </div>
            <div
              className="col-lg-7 col-6"
              style={isEven ? styles.cardRight : styles.cardLeft}
            >
              <div style={styles.skeletonBox}></div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
